import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IOrder} from '../../shared/model/order.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';


type EntityResponseType = HttpResponse<IOrder>;
type EntityArrayResponseType = HttpResponse<IOrder[]>;

@Injectable({providedIn: 'root'})
export class OrderService {
  public resourceUrl = SERVER_API_URL + 'api/orders';

  constructor(protected http: HttpClient) {
  }

  create(order: IOrder): Observable<EntityResponseType> {
    return this.http.post<IOrder>(this.resourceUrl, order, {observe: 'response'});
  }

  update(order: IOrder): Observable<EntityResponseType> {
    return this.http.put<IOrder>(this.resourceUrl, order, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IOrder>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  findOrderCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-all-count'}`, {observe: 'response'});
  }

  findOrderMonthly(param:any): Observable<HttpResponse<any>> {
    return this.http
      .get<IOrder>(`${this.resourceUrl + '-monthly/'+param}`, {observe: 'response'});
  }

  findOrderSumSales(param:any): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-sum-sales/'+param}`, {observe: 'response'});
  }
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrder[]>(this.resourceUrl, {params: options, observe: 'response'});
  }
  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrder[]>(this.resourceUrl+'-search', {params: options, observe: 'response'});
  }

  findWithCustomerId(req?: any, type?:any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrder[]>(this.resourceUrl + '-customer/'+type+'/'+id, {params: options, observe: 'response'});
  }

  // findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<IOrder[]>(this.resourceUrl + '-list-status/'+status, {params: options, observe: 'response'});
  // }

  findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrder[]>(this.resourceUrl+'-list-status/'+status, {params: options, observe: 'response'});
  }


  chekFOrArchive(id?:any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IOrder[]>(this.resourceUrl+'-check-archive/'+id, {params: null, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  confirmSalesFlow(id: number): Observable<EntityResponseType> {
    return this.http.post<IOrder>(`${this.resourceUrl}/${id}/sales-flow/confirm`, {}, {observe: 'response'});
  }

  approveFinanceSalesFlow(id: number): Observable<EntityResponseType> {
    return this.http.post<IOrder>(`${this.resourceUrl}/${id}/sales-flow/approve-finance`, {}, {observe: 'response'});
  }

  revertPreInvoiceSalesFlow(id: number): Observable<EntityResponseType> {
    return this.http.post<IOrder>(`${this.resourceUrl}/${id}/sales-flow/revert-pre-invoice`, {}, {observe: 'response'});
  }

  issueWarehouseSalesFlow(id: number): Observable<EntityResponseType> {
    return this.http.post<IOrder>(`${this.resourceUrl}/${id}/sales-flow/issue-warehouse`, {}, {observe: 'response'});
  }

  cancelSalesFlow(id: number): Observable<EntityResponseType> {
    return this.http.post<IOrder>(`${this.resourceUrl}/${id}/sales-flow/cancel`, {}, {observe: 'response'});
  }

  querySendNotify(req?: any): Observable<HttpResponse<IOrder[]>> {
    const options = createRequestOption(req);

    return this.http.get<any>(this.resourceUrl+'-send-notify', { params: options, observe: 'response' });
  }
}
